export default "/fonts/Muli-Regular.ttf?e9aab0fdac684ccdc422e5f6015e47c5";